(function(w, $) {
    $.publicFetch = function (options) {
        //Build options
        options = $.extend({
            handler: "",
            data: {},
            success: undefined,
            error: undefined,
            complete: undefined,
            type: 'GET'
        }, options || {});

        //Shorthand
        var o = options;

        //Append page and item id
        o.data.BasePageID = w.BasePageID;
        o.data.BaseItemID = w.BaseItemID;

        //Ajax
        if (o.handler.length > 0) {
            return $.ajax({
                url: w.R + "Handlers/Public/" + o.handler + ".ashx",
                data: o.data,
                success: function (data) {
                    if (o.success !== undefined) {
                        o.success(data);
                    }
                },
                error: function (err, type) {
                    //Parse error message
                    var msg;
                    try {
                        msg = $.parseJSON(err.responseText);
                    } catch (ex) {
                        msg = { Message: err.responseText };
                    }

                    //Call error callback
                    if (o.error !== undefined) {
                        o.error(msg || {}, type);
                    }
                },
                complete: options.complete,
                type: options.type
            });
        } else {
            throw 'A handler was not defined in the options when calling publicFetch';
        }
    };
})(window, jQuery);